import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container'];

  startLoading() {
    this.containerTarget.classList.add('loading');
  }
}
